{
  "commonHeader": {
    "toggleSidebar": "Mostra o nascondi la barra laterale",
    "cartLoading": "Caricamento del carrello",
    "cart": "Carrello",
    "aicForAdmin": {
      "ariaLabel": "IA per amministratori"
    },
    "usersResults": "Utenti, {0} risultati",
    "settingsResults": "Impostazioni, {0} risultati",
    "navigationResults": "Navigazione, {0} risultati",
    "learnMoreAbout": "Scopri di più su {0}",
    "close": "Chiudi",
    "products": "Prodotti",
    "moreActions": "Altre azioni",
    "search": "Cerca",
    "searchPlaceholderAll": "Cerca utenti, impostazioni account o navigazione",
    "searchPlaceholderUsers": "Cerca utenti o navigazione",
    "searchPlaceholderSettings": "Cerca impostazioni account o navigazione",
    "searchPlaceholderNav": "Cerca nella navigazione"
  },
  "footerCopyright": {
    "language": "Lingua {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu amministratore"
    }
  },
  "shared": {
    "close": "Chiudi",
    "sideMenu": {
      "personalAria": "Menu personale",
      "adminAria": "Menu amministratore",
      "mainNav": "Navigazione principale",
      "submenu": "Sottomenu",
      "pinnedSection": "{0} aggiunto ai preferiti",
      "sideMenuAria": "Menu laterale",
      "pinItem": "Aggiungi {0} ai preferiti",
      "unpinItem": "Rimuovi {0} dai preferiti",
      "reorderGrabbed": "Riordina {0}, preso. Usa le frecce su e giù per spostare, spazio o Invio per rilasciare, Esc per annullare.",
      "reorderIdle": "Riordina {0}. Premi spazio o Invio per prendere.",
      "hintHandlePin": "Premi Tab per accedere alla maniglia di trascinamento e al pulsante dei preferiti",
      "hintHandle": "Premi Tab per accedere alla maniglia di trascinamento",
      "hintPin": "Premi Tab per accedere al pulsante dei preferiti",
      "upgradeToPro": "Passa a Pro"
    },
    "item": "Elemento"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Prova la nuova esperienza"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Chiudi"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Le divisioni sono ora disponibili"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Gestisci gli account esterni"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "La rubrica diventerà Directory clienti"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Area prodotti",
    "itemLableForFeedback": "Feedback"
  }
}
